import React from 'react';
import styled from 'styled-components';
import { pluralize } from 'utils';

import { validateSeatCount } from 'utils/validators';
import { AlertMessage, Input, inputSizes } from 'components/styled-primitives';
import { SeatSummaryHelpButton, SeatSummaryPanel } from 'components/licenses/seat-summary';
import { Label, InputContainer } from '../../components';

const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.grid.units(1)};
`;

interface SeatStorageManagerProps {
  isCreateLicense?: boolean;
  usedSeats?: number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  seatCount?: number | string;
  /**
   * The license's seat summary. When given, a "?" button beside the Max Seats input shows or
   * hides it in place on click.
   */
  seatSummary?: React.ReactNode;
}

const SeatStorageManager = ({
  isCreateLicense,
  usedSeats,
  onChange,
  seatCount,
  seatSummary,
}: SeatStorageManagerProps): React.JSX.Element => {
  const [showSummary, setShowSummary] = React.useState(false);

  return (
    <InputContainer>
      <Label>Seat Capacity (Max Seats)</Label>
      {!isCreateLicense && <RemainingSeats usedSeats={usedSeats} />}
      <InputRow>
        <Input
          size={inputSizes.MD}
          placeholder="Max Seats"
          height={30}
          onChange={onChange}
          value={seatCount}
          validator={validateSeatCount.validator}
          getValidationMessage={validateSeatCount.getValidationMessage}
        />
        {!!seatSummary && (
          <SeatSummaryHelpButton
            expanded={showSummary}
            onClick={() => setShowSummary((shown) => !shown)}
          />
        )}
      </InputRow>
      {!!seatSummary && showSummary && <SeatSummaryPanel>{seatSummary}</SeatSummaryPanel>}
    </InputContainer>
  );
};

interface RemainingSeatsProps {
  usedSeats?: number;
}

const RemainingSeats = ({ usedSeats }: RemainingSeatsProps): React.JSX.Element => (
  <AlertMessage noIcon>
    <strong>{usedSeats}</strong> {pluralize(usedSeats, 'seat')} currently allocated.
  </AlertMessage>
);

export default SeatStorageManager;
